/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Metadata_Save_Changes_LabelInputs */

const en_event_group_metadata_save_changes_label = /** @type {(inputs: Event_Group_Metadata_Save_Changes_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save metadata changes`)
};

const fr_event_group_metadata_save_changes_label = /** @type {(inputs: Event_Group_Metadata_Save_Changes_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrer les modifications des métadonnées`)
};

const de_event_group_metadata_save_changes_label = /** @type {(inputs: Event_Group_Metadata_Save_Changes_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadatenänderungen speichern`)
};

const it_event_group_metadata_save_changes_label = /** @type {(inputs: Event_Group_Metadata_Save_Changes_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salva le modifiche ai metadati`)
};

const ru_event_group_metadata_save_changes_label = /** @type {(inputs: Event_Group_Metadata_Save_Changes_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сохраните изменения метаданных`)
};

const es_event_group_metadata_save_changes_label = /** @type {(inputs: Event_Group_Metadata_Save_Changes_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardar cambios en los metadatos`)
};

const zh_cn2_event_group_metadata_save_changes_label = /** @type {(inputs: Event_Group_Metadata_Save_Changes_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存元数据更改`)
};

const ja_event_group_metadata_save_changes_label = /** @type {(inputs: Event_Group_Metadata_Save_Changes_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メタデータの変更を保存する`)
};

const hi_event_group_metadata_save_changes_label = /** @type {(inputs: Event_Group_Metadata_Save_Changes_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मेटाडेटा में किए गए बदलावों को सहेजें`)
};

const pt_pt2_event_group_metadata_save_changes_label = /** @type {(inputs: Event_Group_Metadata_Save_Changes_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvar alterações de metadados`)
};

/**
* | output |
* | --- |
* | "Save metadata changes" |
*
* @param {Event_Group_Metadata_Save_Changes_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_metadata_save_changes_label = /** @type {((inputs?: Event_Group_Metadata_Save_Changes_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Metadata_Save_Changes_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_group_metadata_save_changes_label(inputs)
	if (locale === "de") return de_event_group_metadata_save_changes_label(inputs)
	if (locale === "it") return it_event_group_metadata_save_changes_label(inputs)
	if (locale === "ru") return ru_event_group_metadata_save_changes_label(inputs)
	if (locale === "es") return es_event_group_metadata_save_changes_label(inputs)
	if (locale === "zh-CN") return zh_cn2_event_group_metadata_save_changes_label(inputs)
	if (locale === "ja") return ja_event_group_metadata_save_changes_label(inputs)
	if (locale === "hi") return hi_event_group_metadata_save_changes_label(inputs)
	if (locale === "pt-PT") return pt_pt2_event_group_metadata_save_changes_label(inputs)
	return en_event_group_metadata_save_changes_label(inputs)
});